module.exports = __webpack_public_path__ + "media/images/gifts/books/sug_livros_5-ccf5c5b1f27d4bdc28aefba90cb20756.jpg";